import { makeStyles } from '@mui/styles';
const financeDetailsRowSideStyles = makeStyles(({ typography }) => ({
    elementContent: {
        '&$highlighted': {
            fontWeight: typography.fontWeightBold,
        },
        '& h6': {
            display: 'inline-block',
        },
    },
    elementValue: {
        '&$highlighted': {
            fontWeight: typography.fontWeightBold,
        },
    },
    highlighted: {},
    contentLeft: {},
    contentRight: {},
}), {
    name: 'Common_FinanceDetailsRowSide',
});
export default financeDetailsRowSideStyles;
//# sourceMappingURL=financeDetailsRowSide.styles.js.map